import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo, useContext } from 'react'
import { GlobalContext } from '../../../App'
import { metodoPrograma } from '../../../components/api'

const retornaLocalAtendimento = (u = [], idLocalAtendimento) => ({
  idLocalAtendimento: u?.[1] || idLocalAtendimento,
  idConvenio: u?.[0] || undefined,
  dsConvenio: u?.[2] || '',
})

const Edicao = ({ dados, voltar }) => {
  const { localAtendimento } = useContext(GlobalContext)

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <Formik
      initialValues={retornaLocalAtendimento(dados, localAtendimento[0])}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsConvenio"
                label="Convênio"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
